"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    patch: {
        "1": { text: "Invalid arguments given.", name: "patch" },
        "2": {
            text: "Tried to apply patch but failed and rolled back.",
            name: "patch",
        },
        "3": { text: "Patch is not a valid json.", name: "patch" },
    },
    on: {
        "1": { text: "Invalid arguments given", name: "on" },
        "2": { text: "A listener function threw an error", name: "on" },
    },
    db: {
        "1": { text: "Data must be an object literal.", name: "db" },
        "2": {
            text: "Data shouldn't contain protected (add list of) properties.",
            name: "db",
        },
    },
    node: {
        "1": { text: "Node already exists at the given path.", name: "node" },
        "2": { text: "Invalid node arguments given.", name: "node" },
        "3": { text: "Nodes can't be cyclical.", name: "node" },
        "4": {
            text: "The node function need to have the same number of arguments as the dependencies.",
            name: "node",
        },
        "5": { text: "Node was called and an error was raised", name: "node" },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGtCQUFlO0lBQ2IsS0FBSyxFQUFFO1FBQ0wsR0FBRyxFQUFFLEVBQUUsSUFBSSxFQUFFLDBCQUEwQixFQUFFLElBQUksRUFBRSxPQUFPLEVBQUU7UUFDeEQsR0FBRyxFQUFFO1lBQ0gsSUFBSSxFQUFFLGtEQUFrRDtZQUN4RCxJQUFJLEVBQUUsT0FBTztTQUNkO1FBQ0QsR0FBRyxFQUFFLEVBQUUsSUFBSSxFQUFFLDRCQUE0QixFQUFFLElBQUksRUFBRSxPQUFPLEVBQUU7S0FDM0Q7SUFDRCxFQUFFLEVBQUU7UUFDRixHQUFHLEVBQUUsRUFBRSxJQUFJLEVBQUUseUJBQXlCLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRTtRQUNwRCxHQUFHLEVBQUUsRUFBRSxJQUFJLEVBQUUsb0NBQW9DLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRTtLQUNoRTtJQUNELEVBQUUsRUFBRTtRQUNGLEdBQUcsRUFBRSxFQUFFLElBQUksRUFBRSxpQ0FBaUMsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFO1FBQzVELEdBQUcsRUFBRTtZQUNILElBQUksRUFBRSw0REFBNEQ7WUFDbEUsSUFBSSxFQUFFLElBQUk7U0FDWDtLQUNGO0lBQ0QsSUFBSSxFQUFFO1FBQ0osR0FBRyxFQUFFLEVBQUUsSUFBSSxFQUFFLHdDQUF3QyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUU7UUFDckUsR0FBRyxFQUFFLEVBQUUsSUFBSSxFQUFFLCtCQUErQixFQUFFLElBQUksRUFBRSxNQUFNLEVBQUU7UUFDNUQsR0FBRyxFQUFFLEVBQUUsSUFBSSxFQUFFLDBCQUEwQixFQUFFLElBQUksRUFBRSxNQUFNLEVBQUU7UUFDdkQsR0FBRyxFQUFFO1lBQ0gsSUFBSSxFQUNGLGtGQUFrRjtZQUNwRixJQUFJLEVBQUUsTUFBTTtTQUNiO1FBQ0QsR0FBRyxFQUFFLEVBQUUsSUFBSSxFQUFFLHlDQUF5QyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUU7S0FDdkU7Q0FDRixDQUFDIn0=